import React from 'react';
import { BaseModal } from '../BaseModal';
import type { Product } from '../../pages/CatalogPage';
import type { Country } from '../../types';

type PartnerProductModalProps = {
  product: Product;
  onClose: () => void;
  visibleCountries: Country[];
};

export function PartnerProductModal({
  product,
  onClose,
  visibleCountries,
}: PartnerProductModalProps) {
  return (
    <BaseModal isOpen={true} onClose={onClose} title={product.solution} maxWidth="2xl">
      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-foreground mb-1">Platform</h3>
          <p className="text-sm text-muted-foreground">{product.platform}</p>
        </div>

        {product.solution_description && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Description</h3>
            <p className="text-sm text-muted-foreground">{product.solution_description}</p>
          </div>
        )}

        <div>
          <h3 className="text-sm font-medium text-foreground mb-1">Vertical</h3>
          <p className="text-sm text-muted-foreground">{product.vertical}</p>
        </div>

        {product.tag && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-1">Tag</h3>
            <p className="text-sm text-muted-foreground">{product.tag}</p>
          </div>
        )}

        {product.countries && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Country Availability</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {visibleCountries.map(country => {
                const availability = product.countries[country.code];
                return (
                  <div key={country.code} className="flex items-center gap-2 text-sm">
                    <span className="text-base">{country.flag}</span>
                    <span className="text-muted-foreground">{country.code}</span>
                    <span>
                      {availability === true ? (
                        <span className="text-green-600 font-semibold">✓</span>
                      ) : availability === 'Coming Soon' ? (
                        <span className="text-yellow-600 text-xs italic">Soon</span>
                      ) : (
                        <span className="text-red-500 font-semibold">✗</span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {product.notes && (
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Additional Notes</h3>
            <div className="bg-muted/50 border border-border rounded-md p-3">
              <p className="text-sm text-foreground whitespace-pre-wrap">{product.notes}</p>
            </div>
          </div>
        )}
      </div>
    </BaseModal>
  );
};
